/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux';
import { multiFetchApi } from '../../../apiClient';
import history from '../../../utils/history';
import paths from '../../../config/path';
import { apiMap } from '../../../config/constants';
import * as AccountOpeningStepsAction from '../state/action';
import BasePage from '../../../shared/BasePage';
import { Grid } from 'react-bootstrap';
import { FormattedHTMLMessage } from 'react-intl';
import FormTitle from '../../../shared/AOForm/components/FormTitle';
import AOForm from '../../../shared/AOForm';
import { setTitle } from '../../../utils';

import '../style/AccountOpeningSteps.css'
/* eslint-disable array-callback-return */
class AccountOpeningSteps extends BasePage {

    componentDidMount(){
        this.loadContentMessage();
    }
    componentWillReceiveProps = (nextProps) => {
        if (nextProps.selectedLanguage !== this.props.selectedLanguage) {
            this.loadContentMessage();
        }
    }

    loadContentMessage = () => {
        multiFetchApi([apiMap.accountOpeningStepsI18n], [{}])().then(([i18n, ...result]) => {
            if(i18n) {
                this.props.accountOpeningStepsHandle({i18n});
            }
        });
    };
    
    backAction = () => {
        history.push(paths.logon.path);
    }
    onChangeNextSubmit = () => {
        history.push(paths.applicantInformation.path);
    }

    render() {
        const { i18n, pageTitle } = this.props;
        let formTitleContent = {};

        if (i18n) {
           formTitleContent = {
               title: {
                   text: i18n.accountOpeningSteps.title,
                   dataKey: 'accountOpening-steps-title'
               },
               subTitle: {
                   text: i18n.accountOpeningSteps.subTitle,
                   dataKey: 'accountOpening-steps-title'
               }
           };

          if (pageTitle) {
            setTitle( i18n.accountOpeningSteps.title + pageTitle);
          }
        }
        return i18n ? (
            <Grid className="dynamic-form ao-form">

                <FormTitle content={formTitleContent} />

                <div className="form-item">
                    <div className="msg-box warning mainTip">
                        <FormattedHTMLMessage 
                            id="mainTip"
                            defaultMessage={ i18n.mainTip }
                        />
                    </div>
                    <AOForm.ContentOnly
                        content={{
                            title: i18n.steps[0].title,
                            dataKey:'i18n.accountOpeningSteps.title'
                        }}
                    />
                    <ul className="steps-content">
                        <li>{i18n.steps[0].txt1}</li>
                    </ul>
                </div>

                <div className="form-item">
                    <AOForm.ContentOnly
                        content={{
                            title: i18n.steps[1].title,
                            dataKey:'i18n.accountOpeningSteps.title'
                        }}
                    />
                    <ul className="steps-content">
                        <li>{i18n.steps[1].txt1}</li>
                        <li>{i18n.steps[1].txt3}</li>
                    </ul>
                </div>

                <div className="form-item">
                    <AOForm.ContentOnly
                        content={{
                            title: i18n.steps[2].title,
                            dataKey:'i18n.accountOpeningSteps.title'
                        }}
                    />
                    <ul className="steps-content">
                        <li>{i18n.steps[2].txt1}</li>
                    </ul>
                </div>

                {/*BottomButtonsGroup*/}
                <AOForm.BottomButtonsGroup
                        disabled={false}
                        saveButtonShow = {false}
                        content={i18n.bottomButtonsContent}
                        backAction={this.backAction}
                        completeFormAction={this.onChangeNextSubmit}
                    />

            </Grid>
        ) : null
    }
}

AccountOpeningSteps.propTypes = {
    i18n: PropTypes.object
};

const mapStateToProps = (state) => ({
    appInfo: state.app.applicationInfo,
    i18n: state.accountOpeningStepsReducer.i18n,
    accountOpeningSteps: state.accountOpeningStepsReducer,
    selectedLanguage: state.app.selectedLanguage,
    pageTitle: state.app.i18n.pageTitle
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(AccountOpeningStepsAction, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AccountOpeningSteps);


// WEBPACK FOOTER //
// ./src/views/AccountOpeningSteps/container/AccountOpeningSteps.js